import { render, staticRenderFns } from "./SectionSplash.vue?vue&type=template&id=0bb2ecc1&scoped=true&"
import script from "./SectionSplash.vue?vue&type=script&lang=ts&"
export * from "./SectionSplash.vue?vue&type=script&lang=ts&"
import style0 from "./SectionSplash.vue?vue&type=style&index=0&id=0bb2ecc1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb2ecc1",
  null
  
)

export default component.exports